<template>
  <v-list
      dense
      tile
      dark
      class="pa-0 mt-1"
  >
    <template v-for="nav in navItems">
      <NavEntry v-if="!nav.group" :nav="nav" :key="nav.title"></NavEntry>
      <NavGroupEntry :sub="true" v-if="nav.group" :nav="nav" :key="nav.title"></NavGroupEntry>
    </template>
    <v-list-item target="_blank" href="http://archiv.etc-ellerau.de">
      <v-list-item-icon>
        <v-icon>mdi-archive</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Archiv</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
<script>
import NavEntry from "./NavEntry";
import NavGroupEntry from "./NavGroupEntry";

export default {
  components: {NavGroupEntry, NavEntry},
  props: ['navItems']
}
</script>
